<template lang="html">
  <div class="modal">
    <div class="mobile-top-action pt-2 pb-1">
      <button @click="$close(selectedIndex)"
      class="btn btn-link-action">
        <i class="fal fa-times"></i>
      </button>
    </div>
    <div class="select-content">
      <div class="selection">
        <div v-for="(option, index) in options"
        :key="'option-' + index"
        @click="selectOption(index)"
        class="option py-3"
        :class="{ 'selected': index === selectedIndex }">
          {{ option }}
        </div>
      </div>
      <div class="mobile-bottom-spacer" />
    </div>
  </div>
</template>

<script>

export default {
  methods: {
    selectOption(index) {
      this.$close(index);
    }
  },
};
</script>

<style lang="scss" scoped>
$mobile-bar-height: 40px;

.modal {
  background: white;
}

.select-content {
  overflow-y: auto;
  overflow-x: hidden;
  font-family: Scandia-Regular, sans-serif;
  position: absolute;
  height: 100%;
  width: 100%;
}

.selected {
  background-color: var(--action);
  color: var(--action-text);
}

.mobile-bottom-spacer {
  height: $mobile-bar-height + $app-bar-height;
}

.mobile-top-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  z-index: 999;

  .fa-times {
    font-size: 1.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/SingleSelectDialog.vue